import useFadeUp from '../hooks/useFadeUp';
import logo from '../assets/megedLogoTransp.png';
import splash from '../assets/megedSplash.png';

const features = [
    {
        icon: '🗺️',
        title: 'מסלול אישי לכל משפחה',
        desc: 'כל טיול נבנה עבורכם לפי הקצב, התקציב, הרכב המשפחה וטעם האישי.',
    }, 
    {
        icon: '🕍',
        title: 'כשרות ושבת בכל יעד',
        desc: 'מסעדות כשרות מובחרות, הסדרי שבת, בתי כנסת מקומיים - הכל מסודר מראש.',
    },
    {
        icon: '📱',
        title: 'אפליקציה ייחודית לכל מטייל',
        desc: 'כל לקוח מקבל גישה לאפליקציה היעודית שלנו - מסלול יומי, מסמכים, הוצאות, מחשבון המרה והמלצות, הכל במקום אחד.',
    },
    {
        icon: '🕐',
        title: 'זמינות 24/7 - תמיד יש למי להתקשר',
        desc: 'צוות ישראלי זמין לאורך כל הטיול, בכל שעה ובכל מצב. כי שקט נפשי הוא חלק מהחופשה.',
    },
   
    
];

export default function About() {
    const visualRef = useFadeUp(0);
    const textRef = useFadeUp(120);

    return (
        <section id="about" className="py-24 px-6 max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-20 items-center">

                <div ref={visualRef} className="relative flex justify-center">
                    <div className="w-80 h-80 rounded-full border-2 border-brand-blue/15
                flex items-center justify-center">
                        <img src={logo} alt="מגד שמיים" className="w-72 h-72 object-contain mix-blend-multiply opacity-90" />
                    </div>
                    <div className="absolute bottom-0 -left-2 bg-brand-blue text-white
                          rounded-2xl px-6 py-4 text-center shadow-card-lg">
                        <span className="block font-display font-bold text-4xl leading-none">12</span>
                        <span className="block font-body text-xs opacity-80 mt-1 font-light">שנות ניסיון</span>
                    </div>
                    {/* App badge */}
                    <div className="absolute top-0 -right-2 bg-white border border-brand-blue/10
                rounded-2xl p-3 shadow-card">
                        <img src={splash} alt="MegeDigital"
                            className="w-24 h-24 object-contain" />
                    </div>
                </div>

                <div ref={textRef}>
                    <span className="inline-block bg-brand-blue-light text-brand-blue
                           text-[11px] font-bold tracking-[2px] uppercase
                           px-4 py-1.5 rounded-full mb-4">
                        אודות
                    </span>
                    <h2 className="font-display font-bold text-[clamp(1.8rem,3vw,2.6rem)]
                         leading-tight tracking-tight text-gray-900 mb-4">
                        למה מגד שמיים זה לא כמו כולם?
                    </h2>
                    <p className="font-body font-light text-gray-500 text-[1.05rem]
                        leading-relaxed mb-8 max-w-[440px]">
                        אנחנו לא רק מתכננים טיולים - אנחנו דואגים לכם לחוויה יהודית מלאה, שבת, בתי כנסת אוכל כשר, ופתרונות הלכתיים בכל טיול! 
                        <br />הטיולים שלנו הם לא מסלולי מדף, לאחר שיחה מול הלקוח, נתאים עבורכם את הטיול המתאים רק עבורכם! <br />
                        טיסה, לינה, רכב, כיסוי ביטוחי, מסלול מותאם ופתרונות דתיים מלאים לכל יעד! רק אצלנו תוכלו לצאת לטייל בשלווה ובביטחון מלא.
                    </p>
                    <div className="flex flex-col gap-5">
                        {features.map(({ icon, title, desc }) => (
                            <div key={title} className="flex gap-4 items-start">
                                <div className="w-11 h-11 rounded-[14px] bg-brand-blue-light
                                flex items-center justify-center text-xl flex-shrink-0">
                                    {icon}
                                </div>
                                <div>
                                    <h4 className="font-body font-semibold text-[15px] text-gray-900 mb-1">
                                        {title}
                                    </h4>
                                    <p className="font-body font-light text-sm text-gray-500 leading-relaxed">
                                        {desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
}